import moment from 'moment';
import DetailPage from './detail';
import TablePagev2 from '../../../../../components/pages/TablePagev2';
import { Tag } from 'antd';

export default () => {

    const columns = [
        {
            title: 'DATE',
            dataIndex: 'createdAt',
            key: 'createdAt',
            width: 150,
            render: (createdAt) => moment(createdAt).format('DD-MMM-YYYY HH:mm:ss'),
        },
        {
            title: 'ORIGIN',
            dataIndex: 'origin',
            key: 'origin',
            width: 100,
        },
        {
            title: 'DESTINATION',
            dataIndex: 'destination',
            key: 'destination',
            render: (dest) => dest ? dest.join(' ') : '',
            ellipsis: true
        },
        {
            title: 'SMI',
            dataIndex: 'smi',
            key: 'smi',
            width: 80,
            search: true
        },
        {
            title: 'SUBJECT',
            dataIndex: 'msgid',
            key: 'msgid',
        },
        {
            title: 'MESSAGE',
            dataIndex: 'message',
            key: 'message',
            search: true,
            ellipsis: true
        },
        {
            title: 'PRIORITY',
            dataIndex: 'priority',
            key: 'priority',
            width: 90,
            render: (priority) => {
                const code = priority?.code?.toUpperCase();
                if (code === 'QU') {
                    return <Tag color="red">HIGH</Tag>;
                } else if (code === 'QK') {
                    return <Tag color="orange">NORMAL</Tag>;
                } else {
                    return <Tag color="green">LOW</Tag>;
                }
            },
        },
        {
            title: 'CORID',
            dataIndex: 'corid',
            key: 'corid',
            width: 90,
        },
    ];

    return (
        <TablePagev2
            title={"Telex"}
            url="api/v1/telex"
            columns={columns}
            actionPosition={'first'}
            expandableComponent={{
                expandedRowRender: record => (
                    <DetailPage record={record} />
                ),
            }}
        />
    )
}